'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var accordion = require('../components/accordion.js');
var advert = require('../adverts/advert.js');
var scroll = require('../ui/scroll.js');

var $latestModelsTab = $('#latestModelsTab');
var $olderModelsTab = $('#olderModelsTab');

var $latestModelsContainer = $('#latestModelsContainer');
var $olderModelsContainer = $('#olderModelsContainer');

var classNames = {
	toggleSwitch: 'toggle-switch__switch',
	vehicleSelectorOlderModelsButton: 'vehicle-selector__older-models-button',
	accordionNavigation: 'accordion__navigation',
	accordionContent: 'accordion__content',
	button: 'button'
};

var modifierNames = {
	active: 'active',
	expanded: 'expanded'
};

function loadAdsInContext() {
	var $context = $('#tabPanels');

	advert.loadAds($context);
}

function latestModelsTabClick() {
	$latestModelsTab.on('click', function() {
		if ($latestModelsTab.hasBemClass(classNames.toggleSwitch, null, modifierNames.active)) {
			return;
		}

		$latestModelsTab.addBemClass(classNames.toggleSwitch, null, modifierNames.active)
		.attr('aria-selected', true);

		$latestModelsContainer.show();

		$olderModelsTab.removeBemClass(classNames.toggleSwitch, null, modifierNames.active)
		.attr('aria-selected', false);

		$olderModelsContainer.hide();

		loadAdsInContext();
	});
}

function reInitDataEqualizer() {
	$(document).foundation().init('equalizer');
}

function olderModelsTabClick() {
	$olderModelsTab.on('click', function() {
		if ($olderModelsTab.hasBemClass(classNames.toggleSwitch, null, modifierNames.active)) {
			return;
		}

		$olderModelsTab.addBemClass(classNames.toggleSwitch, null, modifierNames.active)
		.attr('aria-selected', true);

		$olderModelsContainer.show();

		$latestModelsTab.removeBemClass(classNames.toggleSwitch, null, modifierNames.active)
		.attr('aria-selected', false);

		$latestModelsContainer.hide();

		reInitDataEqualizer();

		loadAdsInContext();
	});
}

function expandModelInAccordion(modelName) {
	var $olderModelsAccordion = $('#olderModelsAccordion');

	$olderModelsAccordion.findByBem(classNames.accordionNavigation, null, modifierNames.expanded)
		.removeBemClass(classNames.accordionNavigation, null, modifierNames.expanded);
	
	$olderModelsAccordion.findByBem(classNames.accordionContent, null, modifierNames.expanded)
		.removeBemClass(classNames.accordionContent, null, modifierNames.expanded);

	$olderModelsAccordion.findByBem(classNames.accordionContent).hide();

	$olderModelsTab.addBemClass(classNames.toggleSwitch, null, modifierNames.active)
	.attr('aria-selected', true);

	$olderModelsContainer.show();

	$latestModelsTab.removeBemClass(classNames.toggleSwitch, null, modifierNames.active)
	.attr('aria-selected', false);

	$latestModelsContainer.hide();

	var $accordionPositionModelName = $('#accordionPosition-' + modelName);
	$accordionPositionModelName.findByBem(classNames.accordionNavigation)
		.addBemClass(classNames.accordionNavigation, null, modifierNames.expanded);

	var $accordionContentModelName = $('#accordionContent-' + modelName);
	$accordionContentModelName.findByBem(classNames.accordionContent)
		.addBemClass(classNames.accordionContent, null, modifierNames.expanded);

	$accordionContentModelName.show();
	scroll.scrollIntoView($accordionPositionModelName);
	loadAdsInContext();
}

function olderModelsButtonClick() {
	$('.' + classNames.vehicleSelectorOlderModelsButton).each(function() {
		var olderModelButtonId = $(this).findByBem(classNames.button).attr('id');
		$('#' + olderModelButtonId).on('click', function() {
			var buttonPrefix = 'olderModelButton-';
			var modelName = olderModelButtonId.replace(buttonPrefix, '');

			expandModelInAccordion(modelName);

			reInitDataEqualizer();
		});
	});
}

basePage.init = function() {
	basePage.initBasePage();
	accordion.init(null, null, true);

	latestModelsTabClick();
	olderModelsTabClick();
	olderModelsButtonClick();
};

module.exports = basePage; 